import type { OldUserData } from '~/types';
import { isObject } from '~/utils';
import type { UserAvatar } from '@devhacker/shared/features/user/types/userAvatar';
import type { User } from '@devhacker/shared/features/user/types/user';

export const normalizeUserData = (data: User): OldUserData => {
  const def: OldUserData = {
    displayName: 'unknown',
    name: 'unknown',
    email: 'unknown',
    archivedAt: null,
    banned: false,
    integerId: null,
    sub: null,
    vkId: null,
    avatars: {},
    avatar: null,
  };

  if (!isObject(data)) {
    return def;
  }

  const avatars: OldUserData['avatars'] = {};
  if (data.avatars && data.avatars.length) {
    data.avatars.forEach((avatar: UserAvatar): void => {
      avatar && (avatars[avatar.size] = avatar.url);
    });
  }

  const avatar: string | null = avatars.m || avatars.s || avatars.l || avatars.xs || null;

  return {
    avatar,
    avatars,
    displayName: data.display_name || def.displayName,
    name: data.display_name || def.name,
    email: data.email || def.email,
    archivedAt: data.banned_at || def.archivedAt,
    banned: Boolean(data.banned_at),
    integerId: data.integer_id || def.integerId,
    sub: data.integer_id || def.sub,
    vkId:
      (data.socials?.vkid?.id != null ? String(data.socials.vkid.id) : null) ||
      data.vk_id ||
      def.vkId,
  };
};
